import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "tab-shell" }
const _hoisted_2 = { class: "tab-head" }
const _hoisted_3 = { class: "filter-tabs" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "empty-hint"
}
const _hoisted_6 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_7 = {
  key: 2,
  class: "nf-list"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "nf-card-main" }
const _hoisted_10 = { class: "nf-row" }
const _hoisted_11 = { class: "nf-numero" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "nf-meta" }
const _hoisted_14 = { class: "nf-row nf-row--sub" }
const _hoisted_15 = { class: "nf-meta" }
const _hoisted_16 = {
  key: 0,
  class: "nf-meta"
}
const _hoisted_17 = { class: "nf-valor" }
const _hoisted_18 = {
  key: 0,
  class: "nf-expanded"
}
const _hoisted_19 = {
  key: 0,
  class: "items-loading"
}
const _hoisted_20 = {
  key: 0,
  class: "items-empty"
}
const _hoisted_21 = {
  key: 1,
  class: "items-table"
}
const _hoisted_22 = { class: "status-change-row" }
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = ["value"]
const _hoisted_25 = ["disabled", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "tab-title" }, "Notas Fiscais", -1)),
      _createElementVNode("button", {
        class: "btn-primary",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('import-nf')))
      }, [...(_cache[1] || (_cache[1] = [
        _createStaticVNode("<svg width=\"13\" height=\"13\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.2\" data-v-28f2f8e1><path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\" data-v-28f2f8e1></path><polyline points=\"14 2 14 8 20 8\" data-v-28f2f8e1></polyline><line x1=\"12\" y1=\"18\" x2=\"12\" y2=\"12\" data-v-28f2f8e1></line><line x1=\"9\" y1=\"15\" x2=\"15\" y2=\"15\" data-v-28f2f8e1></line></svg> Importar NF ", 2)
      ]))])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusFilters, (f) => {
        return (_openBlock(), _createElementBlock("button", {
          key: f.value,
          class: _normalizeClass(["filter-tab", { active: _ctx.statusFilter === f.value }]),
          type: "button",
          onClick: ($event: any) => (_ctx.statusFilter = f.value)
        }, _toDisplayString(f.label), 11, _hoisted_4))
      }), 128))
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Carregando..."))
      : (_ctx.filteredNfs.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("svg", {
              width: "36",
              height: "36",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.4"
            }, [
              _createElementVNode("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }),
              _createElementVNode("polyline", { points: "14 2 14 8 20 8" })
            ], -1),
            _createTextVNode(" Nenhuma nota fiscal encontrada. ", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredNfs, (nf) => {
              return (_openBlock(), _createElementBlock("article", {
                key: nf.id,
                class: "nf-card"
              }, [
                _createElementVNode("div", {
                  class: "nf-card-header",
                  onClick: ($event: any) => (_ctx.toggleExpand(nf.id))
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, [
                        _createTextVNode("NF " + _toDisplayString(nf.numero), 1),
                        (nf.serie)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, " · Série " + _toDisplayString(nf.serie), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", {
                        class: _normalizeClass(["status-chip", _ctx.statusClass(nf.status)])
                      }, _toDisplayString(_ctx.statusLabel(nf.status)), 3)
                    ]),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(nf.emitenteNome || nf.emitenteCNPJ || '—'), 1),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.formatDate(nf.dataEmissao)), 1),
                      (nf.projeto)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, "· " + _toDisplayString(nf.projeto), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formatCurrency(nf.valorTotal)), 1)
                    ])
                  ]),
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass(["expand-icon", { expanded: _ctx.expanded.has(nf.id) }]),
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2"
                  }, [...(_cache[4] || (_cache[4] = [
                    _createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
                  ]))], 2))
                ], 8, _hoisted_8),
                (_ctx.expanded.has(nf.id))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (_ctx.loadingItems.has(nf.id))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Carregando itens..."))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            ((_ctx.itemsMap[nf.id] || []).length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Sem itens registrados."))
                              : (_openBlock(), _createElementBlock("table", _hoisted_21, [
                                  _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("th", null, "Descrição"),
                                      _createElementVNode("th", null, "Qtd"),
                                      _createElementVNode("th", null, "Vlr Unit."),
                                      _createElementVNode("th", null, "Total")
                                    ])
                                  ], -1)),
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsMap[nf.id], (it) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: it.id
                                      }, [
                                        _createElementVNode("td", null, _toDisplayString(it.descricao), 1),
                                        _createElementVNode("td", null, _toDisplayString(it.quantidade), 1),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.formatCurrency(it.valorUnitario)), 1),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.formatCurrency(it.quantidade * it.valorUnitario)), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ])),
                            _createElementVNode("div", _hoisted_22, [
                              _cache[7] || (_cache[7] = _createElementVNode("label", { class: "status-label-inline" }, "Atualizar status:", -1)),
                              _withDirectives(_createElementVNode("select", {
                                class: "status-select",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.statusChangeMap[nf.id]) = $event)
                              }, [
                                _cache[6] || (_cache[6] = _createElementVNode("option", { value: "" }, "Selecionar...", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nextStatuses(nf.status), (s) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: s.value,
                                    value: s.value
                                  }, _toDisplayString(s.label), 9, _hoisted_24))
                                }), 128))
                              ], 8, _hoisted_23), [
                                [_vModelSelect, _ctx.statusChangeMap[nf.id]]
                              ]),
                              _createElementVNode("button", {
                                class: "btn-status-save",
                                type: "button",
                                disabled: !_ctx.statusChangeMap[nf.id] || _ctx.savingStatus.has(nf.id),
                                onClick: ($event: any) => (_ctx.saveStatus(nf.id))
                              }, _toDisplayString(_ctx.savingStatus.has(nf.id) ? '...' : 'Salvar'), 9, _hoisted_25)
                            ])
                          ], 64))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
  ]))
}